import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vmSalesCurrency',
})
export class VmSalesCurrencyPipe extends CurrencyPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    value = parseFloat(value);
    let transformedValue = super.transform(value, ...args);
    if (this.countDecimals(value) === 1) {
      transformedValue = transformedValue.concat('0');
    }
    return transformedValue;
  }

  countDecimals(value: any) {
    if (Math.floor(value?.valueOf()) === value?.valueOf()) {
      return 0;
    }
    return value?.toString()?.split('.')[1]?.length || 0;
  }
}
